import React, { forwardRef } from 'react';
import Loading from '../Loading';
import { ButtonWrapper } from './Button.styles';

interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  as?: any;
  size?: 'small' | 'large' | 'default';
  varient?: 'primary' | 'secondary' | 'link' | 'muted';
  loading?: boolean;
  disabled?: boolean;
  danger?: boolean | undefined;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      size = 'default',
      varient = 'primary',
      loading,
      disabled,
      as,
      className,
      danger,
      type = 'button',
      ...props
    },
    ref
  ) => (
    <ButtonWrapper
      ref={ref}
      as={as}
      size={size}
      varient={varient}
      disabled={disabled}
      loading={loading}
      type={type}
      className={className}
      danger={danger}
      {...props}
    >
      <span className="label">
        {loading && <Loading size={size} />}
        {children}
      </span>
    </ButtonWrapper>
  )
);

export default Button;
Button.displayName = 'Button';
